/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Button from "./com/button";

const ForgotPg = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [submitText, setSubmitText] = useState("Send Email");
  const { handleSubmit, register, errors } = useForm();
  const [showPopup, setShowPopup] = useState(false);

  const setButtonText = (txt, ca = () => {}, cb = () => {}, wait = 4) => {
    cb();
    setIsLoading(false);
    setSubmitText(txt);
    ca &&
      setTimeout(() => {
        setSubmitText("Send Email");
        ca();
      }, wait * 1000);
  };

  const onForgot = async ({ username }) => {
    if (!navigator.onLine) return setButtonText("Please check your Internet connection") && false;
    try {
      setIsLoading(true);
      const parms = { headers: { "Content-Type": "application/json" } };
      const r = await fetch("/patientmanagement/rest/users/resetPassword?email=" + username, parms);
      if (r.ok)
        return setButtonText("Please check your inbox for password reset email", null, () =>
          setIsDisabled(true)
        );
      const j = await r.json();
      setButtonText(j.errors[0].msg);
      if (j.errors[0].msg == "Too many password reset requests.") {
        setShowPopup(true);
      }
    } catch (error) {
      setButtonText("Connectivity problem.  Please try again later.");
    }
  };

  const popupModalValidation = () => {
    return showPopup ? (
      <div className="modal override-row popup show" id="modalAgreements">
        <div className="modalContent">
          <div className="grpHdr">
            <h2>Too many password reset requests.</h2>
          </div>
          <p>
            {`We're sorry, but there have been too many password reset requests for your account in a short
            period. For security reasons, we've temporarily restricted further reset attempts. If you are
            having trouble accessing your account, please wait for a while before trying again. If the issue
            persists, or if you believe this is an error, contact our support team at
            customersuccess@philips.com/844-525-5115 for assistance. Thank you for your understanding.`}
          </p>
          <div className="row rowStretch noMargin">
            <button className="btn btn-sm btn-teal" id="popup-ok-btn" onClick={() => setShowPopup(false)}>
              OK
            </button>
          </div>
        </div>
      </div>
    ) : null;
  };

  return (
    <div className="page">
      <div className="geneva-logo" style={{ transform: "scale(0.6)" }} />
      <div className="root">
        <form onSubmit={handleSubmit(onForgot)} className="tl-form">
          <div className="area">
            <h1>Forgot Password</h1>
            <input
              className="tl-inp"
              disabled={isLoading || isDisabled}
              type="text"
              placeholder="Enter email..."
              name="username"
              ref={register({
                required: "Email is required",
                pattern: {
                  value: /^([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})$/i,
                  message: "Invalid email address",
                },
              })}
            />
            <span className="err">{errors.username && errors.username.message}</span>
          </div>
          <Button className="btn tl-btn" disabled={isDisabled} type="submit" isLoading={isLoading}>
            {" "}
            &nbsp; {submitText}{" "}
          </Button>
        </form>
      </div>
      {popupModalValidation()}
    </div>
  );
};

export default ForgotPg;
